import { getFile } from "sr/utils/api/getFile";

type Params = {
  files?: string[] | any[];
  setPreviewImages?: (items: any[]) => void;
  previewImages?: any[];
  type?: 'images' | 'videos';
  previewVideo?: any[];
  setPreviewVideo?: (items: any[]) => void;
  setLoader?: (val: boolean) => void;
};

const fetchFile = async (key: string) => {
  const asUrl = await getFile(key, 'url');
  if (asUrl) return asUrl;
  return await getFile(key);
};

export const setPreview = async (params: Params) => {
  params?.setLoader && params.setLoader(true);

  if (params?.files?.length) {
    const videos: any[] = [];
    const images: any[] = [];

    for (const item of params.files as any[]) {
      const data: any = await fetchFile(item as any);
      if (!data) continue;

      const url = data instanceof Blob ? URL.createObjectURL(data) : data;

      if (params?.type === 'images') {
        images.push({ blob: url, key: item });
      } else if (params?.type === 'videos') {
        videos.push({ blob: url, key: item });
      }
    }

    if (params?.type === 'images' && params.setPreviewImages) {
      params.setPreviewImages(images);
    }
    if (params?.type === 'videos' && params.setPreviewVideo) {
      params.setPreviewVideo(videos);
    }
  }

  params?.setLoader && params.setLoader(false);
};

export default setPreview;
